import { type HgSelectOptions } from '@smg-real-estate/domus';
import { type TranslateResult } from 'vue-i18n';

export enum CustomerSegment {
  TENANT = 'tenant',
  OWNER = 'owner',
  PROFESSIONAL = 'professional',
}
export const allCustomerSegments = [
  CustomerSegment.TENANT,
  CustomerSegment.OWNER,
  CustomerSegment.PROFESSIONAL,
];

export const getCustomerSegmentSelectOptions = (
  translate: (key: string) => TranslateResult,
): HgSelectOptions[] =>
  allCustomerSegments.map((customerSegment) => ({
    text: translate(
      `landingPage.customerSegmentSection.customerSegments.${customerSegment}`,
    ).toString(),
    value: customerSegment as string,
  }));

/***
 * Returns the Customer Segment as a string for Google Analytics tracking.
 *
 * @remarks
 * The Customer Segment 'Other' has an underscore at the end, which is not wanted for tracking. It may be required
 * in other places, so this method explicitly removes it.
 *
 * @param customerSegment
 */
export function customerSegmentTrackingString(
  customerSegment: CustomerSegment | string | undefined,
): string {
  if (!customerSegment || customerSegment.trim() === '') {
    return '';
  }
  return customerSegment.replace(/_/, '');
}
